module.exports = __webpack_public_path__ + "static/website-9958caa93b713e78de3466f0b75c67a7.png";